import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface DialogData {
    action: string;
}

@Component({
    selector: 'app-save-dialog',
    templateUrl: 'save.dialog.html',
    styleUrls: ['dialog.scss'],
})

export class SaveDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<SaveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    OnCancelClick(): void {
        this.dialogRef.close();
    }
}
